/**
 * Free gift: auto-add 3x "Free Gift: Organic Miswak Twig" when cart subtotal (excluding the gift) reaches the threshold.
 * Oct 6 12:00am ET to Oct 12 12:00am ET 2026. Pairs with the automatic discount
 * "Free 3 Miswak Twigs with $50+", which makes the gift line free.
 * The gift is a separate hidden product so Appstle's miswak bundle discount doesn't apply to it.
 * Threshold: 50 in USD and GBP; other currencies use the USD amount converted at the store rate.
 */
(function () {
  var CFG = {
    variantId: 67620287283296,
    qty: 3,
    threshold: 50,
    startsAt: Date.parse('2026-10-06T04:00:00Z'),
    endsAt: Date.parse('2026-10-12T04:00:00Z'),
    prop: '_free_gift'
  };

  var origFetch = window.fetch.bind(window);
  var busy = false;
  var timer = null;

  function thresholdCents() {
    var s = window.Shopify && window.Shopify.currency;
    var cur = (s && s.active) || 'USD';
    var rate = parseFloat(s && s.rate) || 1;
    var amount = cur === 'USD' || cur === 'GBP' ? CFG.threshold : CFG.threshold * rate;
    return Math.round(amount * 100);
  }

  function post(url, body) {
    return origFetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  async function sync() {
    if (busy) return;
    busy = true;
    try {
      var now = Date.now();
      var active = now >= CFG.startsAt && now < CFG.endsAt;
      var res = await origFetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
      var cart = await res.json();
      var gift = null;
      var subtotal = 0;
      cart.items.forEach(function (item) {
        if (item.variant_id === CFG.variantId) {
          gift = item;
        } else {
          subtotal += item.original_line_price;
        }
      });
      var want = active && subtotal >= thresholdCents() ? CFG.qty : 0;
      var have = gift ? gift.quantity : 0;
      if (want === have) return;
      if (gift) {
        await post('/cart/change.js', { id: gift.key, quantity: want });
      } else {
        var props = {};
        props[CFG.prop] = 'true';
        await post('/cart/add.js', { items: [{ id: CFG.variantId, quantity: want, properties: props }] });
      }
      document.dispatchEvent(new CustomEvent('theme:update:cart'));
    } catch (e) {
      console.error('free-gift sync failed', e);
    } finally {
      busy = false;
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 400);
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    var p = origFetch(input, init);
    if (method !== 'GET' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(schedule, function () {});
    }
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('pageshow', schedule);
})();
